import React, { useEffect, useRef, useState } from 'react'
import { Navbar } from './Navbar'
import SoundDecision from './SoundDecision';
import { useGameSettings } from './slotGame/slotData';
import SlotMachine from './slotGame/SlotMachine';
import Paylines from './action/actionItems/Paylines';
import { PayTable } from './sidebar/sidebarItems/PayTable';
import SystemSettings from './action/actionItems/SystemSettings';
import { History } from './sidebar/sidebarItems/History';
import AutoPlay from './action/actionItems/AutoPlay';
import { useDispatch } from 'react-redux';
import { sendAutoPlayData } from '../redux/slices/autoPlaySlice';
import BetMultiplier from './action/actionItems/BetMultiplier';
import FreeSpin from './slotGame/FreeSpin';
import { resetFreeSpin } from '../redux/slices/freeSpinSlice';
import { imageKeysToPreloadInSlotMachine, imagesToPreloadInSlotMachine, preloadImages } from '../utills/preloadAssets';
import GameLoading from './GameLoading';
import JackpotNavbar from './JackpotNavbar';

const GamePopup = () => {

    const { balanceForConfig, gameBackgroundUrl, navbarBackgroundUrl, line, baseAudioUrl, jackpotDetailAvailable, minBet } = useGameSettings()
    const dispatch = useDispatch();

    const gameSettings = useGameSettings();
    const [slotMachineAssetsLoaded, setSlotMachineAssetsLoaded] = useState(false)
    const [showOverlay, setShowOverlay] = useState(true)

    const [activeModel, setActiveModel] = useState(null)
    const [bet, setBet] = useState(5)
    const [balance, setBalance] = useState(0)
    const [win, setWin] = useState(0)
    // const [spaceForSpin, setSpaceForSpin] = useState(true)
    const [soundDecisionMade, setSoundDecisionMade] = useState(false)
    const [soundOn, setSoundOn] = useState(false);
    const [soundEffectFile, setSoundEffectFile] = useState("")
    const [ambientMusic, setAmbientMusic] = useState(false)
    const [volume, setVolume] = useState(0);
    const [lineForBet, setLineForBet] = useState(line)
    const [showPaylines, setShowPaylines] = useState(false)
    const [turboOn, setTurboOn] = useState(false)
    const [showPayTable, setShowPayTable] = useState(false)
    const [showVolume, setShowVolume] = useState(false)
    const [showSettings, setShowSettings] = useState(false)
    const [showHistory, setShowHistory] = useState(false)
    const [showAutoPlay, setShowAutoPlay] = useState(false)
    const [autoPlay, setAutoPlay] = useState(false)
    const [countAutoPlay, setCountAutoPlay] = useState(-1)
    const [winLineCount, setWinLineCount] = useState(0)
    const [showBetMultiplier, setShowBetMultiplier] = useState(false)
    const [betAction, setBetAction] = useState("")
    const [playFreeSpin, setPlayFreeSpin] = useState(false)
    const [freeSpinAutoPlayCount, setFreeSpinAutoPlayCount] = useState(0)
    const [freeSpinDetail, setFreeSpinDetail] = useState({
        type: "",
        featureWin: 0,
        totalProfit: 0,
        gameWin: 0,
        jackPotWin: 0,
        spinCount: 0,
        spinLimit: 0,
        showFreeSpin: false
    })
    const [autoPlayLimit, setAutoPlayLimit] = useState({
        winLimit: balance || 0,
        lossLimit: balance || 0
    })
    const [notificationMsg, setNotificationMsg] = useState("")
    const audioRef = useRef(null);
    const audioEffectRef = useRef(null)
    const volumeRef = useRef(null);
    const slotMachineRef = useRef(null)

    useEffect(() => {
        setBalance(balanceForConfig)
    }, [balanceForConfig])

    useEffect(() => {
        setBet(minBet)
    }, [minBet])

    useEffect(() => {
        if (soundDecisionMade && !slotMachineAssetsLoaded) {
            const imagesFromKeys = imageKeysToPreloadInSlotMachine
                .map((key) => gameSettings[key])
                .filter(Boolean);

            const symbolImages = (gameSettings?.symbols || [])
                .map((symbol) => symbol.image_url)
                .filter(Boolean); // Each symbol's AWS image URL

            const allImages = [...imagesToPreloadInSlotMachine, ...imagesFromKeys, ...symbolImages];
            // const audioFromKeys = audioKeysToPreloadInSlotMachine
            //     .map((key) => gameSettings[key])
            //     .filter((src) => typeof src === 'string' && src.endsWith('.mp3'));

            Promise.all([
                preloadImages(allImages),
                // preloadAudios(audioFromKeys)
            ])
                .then(() => {
                    setSlotMachineAssetsLoaded(true);
                    console.log("✅ All AWS images and audio files preloaded");
                })
                .catch((err) => {
                    console.error("❌ Error preloading assets:", err);
                });
        }
    }, [gameSettings, slotMachineAssetsLoaded, soundDecisionMade])

    useEffect(() => {
        if (slotMachineAssetsLoaded) {
            const timeout = setTimeout(() => {
                setShowOverlay(false);
            }, 1500); // show loading for 2 more seconds

            return () => clearTimeout(timeout);
        }
    }, [slotMachineAssetsLoaded]);

    const handleSpinCallback = () => {
        if (slotMachineRef.current) {
            slotMachineRef.current.handleSpin()
        }
    }

    // Ensure volume updates apply dynamically
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = volume / 100;
        }
    }, [volume]);

    // Play or pause audio based on `soundOn`setTurboON
    // Play/pause ambient music based on user preference
    useEffect(() => {
        if (soundDecisionMade && audioRef.current) {
            if (ambientMusic) {
                audioRef.current.loop = true;
                audioRef.current.play().catch(err => console.error("Error playing ambient music:", err));
            } else {
                audioRef.current.pause();
            }
        }
    }, [soundDecisionMade, ambientMusic]);

    // Play sound effect ONCE whenever a new soundEffectFile is set
    useEffect(() => {
        if (soundDecisionMade && soundOn && audioEffectRef.current && soundEffectFile) {
            const audioEffect = audioEffectRef.current;
            audioEffect.volume = 1
            audioEffect.pause();
            audioEffect.removeAttribute('src');
            audioEffect.load();
            audioEffect.src = soundEffectFile; // cache bust
            audioEffect.play().catch(err => console.error("Error playing sound effect:", err));
        }
    }, [soundEffectFile, soundDecisionMade, soundOn]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (volumeRef.current && !volumeRef.current.contains(event.target)) {
                setShowVolume(false);
                setActiveModel(null)
            }
        }

        if (showVolume) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showVolume]);

    const stopAutoPlay = async () => {
        try {
            const response = await dispatch(sendAutoPlayData({ autoSpin: false })).unwrap();
            if (response.success) {
                setAutoPlay(false)
                setCountAutoPlay(-1)
            }
        } catch (error) {
            console.error("Error Response:", error);
        }
    }

    useEffect(() => {
        if (
            playFreeSpin &&
            freeSpinDetail.showFreeSpin &&
            freeSpinDetail.type !== "" &&
            freeSpinDetail.type !== "TotalFreeSpin"
        ) {
            const timeout = setTimeout(() => {
                setFreeSpinDetail(prev => ({
                    ...prev,
                    type: "",
                    showFreeSpin: false
                }));
            }, 1000);

            dispatch(resetFreeSpin());

            return () => clearTimeout(timeout);
        }
    }, [freeSpinDetail.showFreeSpin, freeSpinDetail.type, playFreeSpin, dispatch]);

    useEffect(() => {
        setFreeSpinAutoPlayCount(freeSpinDetail.spinLimit - freeSpinDetail.spinCount - 1);
    }, [freeSpinAutoPlayCount, freeSpinDetail.spinCount, freeSpinDetail.spinLimit]);

    useEffect(() => {
        if ((autoPlay || playFreeSpin) && turboOn) {
            setTurboOn(false)
        }
    }, [autoPlay, playFreeSpin, turboOn])

    return (
        <div
            className='flex flex-col h-screen w-screen overflow-hidden flex-1 bg-[#12151D] bg-contain'
            style={{
                backgroundImage: `url(${gameBackgroundUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}
        >
            {/* Background Music */}
            <audio ref={audioRef} src={baseAudioUrl} loop />
            <audio ref={audioEffectRef} />

            {!showHistory && !freeSpinDetail.showFreeSpin && <>
                {soundDecisionMade ? (
                    slotMachineAssetsLoaded ? (
                        <>
                            {showOverlay && (
                                <div className="absolute top-0 left-0 w-screen h-screen z-50">
                                    <GameLoading />
                                </div>
                            )}
                            <div className="flex flex-col w-screen h-screen relative">

                                {jackpotDetailAvailable &&
                                    <div
                                        className="absolute top-0 h-[10%] w-full flex items-end justify-end bg-center bg-no-repeat bg-contain backdrop-blur shadow-[0_6px_12px_rgba(0,0,0,0.6)]"
                                        style={{
                                            backgroundImage: `url(/jackpot-navbar-bg.png)`,
                                            backgroundSize: "110% 100%",
                                            filter: `
                                        drop-shadow(0px -4px 10px rgba(0, 0, 0, 0.5)) 
                                        drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.5))
                                        `,
                                        }}
                                    >
                                        <JackpotNavbar />
                                    </div>
                                }

                                <div
                                    className="relative flex-1 flex items-center justify-center bg-center bg-no-repeat bg-cover lg:bottom-0 xl:bottom-3"
                                    style={{
                                        backgroundImage: "url('/slot-machine-bg.png')",
                                        backgroundSize: "103% 89%",
                                    }}
                                >
                                    <SlotMachine
                                        bet={bet}
                                        setBet={setBet}
                                        balance={balance}
                                        setBalance={setBalance}
                                        win={win}
                                        setWin={setWin}
                                        lineForBet={lineForBet}
                                        turboOn={turboOn}
                                        ref={slotMachineRef}
                                        autoPlay={autoPlay}
                                        countAutoPlay={countAutoPlay}
                                        setCountAutoPlay={setCountAutoPlay}
                                        setWinLineCount={setWinLineCount}
                                        playFreeSpin={playFreeSpin}
                                        setPlayFreeSpin={setPlayFreeSpin}
                                        setFreeSpinDetail={setFreeSpinDetail}
                                        freeSpinAutoPlayCount={freeSpinAutoPlayCount}
                                        setFreeSpinAutoPlayCount={setFreeSpinAutoPlayCount}
                                        setSoundEffectFile={setSoundEffectFile}
                                        setActiveModel={setActiveModel}
                                        setNotificationMsg={setNotificationMsg}
                                        autoPlayLimit={autoPlayLimit}
                                        stopAutoPlay={stopAutoPlay}
                                    />
                                </div>

                                <div
                                    className="absolute bottom-0 h-[15%] w-full flex items-end justify-end bg-center bg-no-repeat bg-contain"
                                    style={{
                                        backgroundImage: `url( ${navbarBackgroundUrl} )`,
                                        backgroundSize: "100% 100%",
                                        filter: "drop-shadow(0px -4px 10px rgba(0, 0, 0, 0.5))",
                                    }}
                                >
                                    <Navbar
                                        balance={balance}
                                        bet={bet} win={win}
                                        setShowPaylines={setShowPaylines}
                                        turboOn={turboOn}
                                        setTurboOn={setTurboOn}
                                        setShowPayTable={setShowPayTable}
                                        setShowVolume={setShowVolume}
                                        setShowSettings={setShowSettings}
                                        handleSpinCallback={handleSpinCallback}
                                        setShowAutoPlay={setShowAutoPlay}
                                        stopAutoPlay={stopAutoPlay}
                                        autoPlay={autoPlay}
                                        countAutoPlay={countAutoPlay}
                                        winLineCount={winLineCount}
                                        setShowBetMultiplier={setShowBetMultiplier}
                                        setBetAction={setBetAction}
                                        playFreeSpin={playFreeSpin}
                                        freeSpinAutoPlayCount={freeSpinAutoPlayCount}
                                        setSoundEffectFile={setSoundEffectFile}
                                        activeModel={activeModel}
                                        setActiveModel={setActiveModel}
                                        notificationMsg={notificationMsg}
                                    />
                                </div>
                            </div>
                        </>
                    ) : <GameLoading />)
                    :
                    <SoundDecision setSoundDecisionMade={setSoundDecisionMade} setSoundOn={setSoundOn} setAmbientMusic={setAmbientMusic} setVolume={setVolume} />
                }
            </>}
            {freeSpinDetail.showFreeSpin && <FreeSpin freeSpinDetail={freeSpinDetail} setFreeSpinDetail={setFreeSpinDetail} setPlayFreeSpin={setPlayFreeSpin} setFreeSpinAutoPlayCount={setFreeSpinAutoPlayCount} setSoundEffectFile={setSoundEffectFile} />}
            {(showPaylines || showPayTable || showSettings || showAutoPlay) &&
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div
                        className="rounded-lg shadow-lg w-[75%] h-[90%] lg:h-[75%] relative flex flex-col border-[0.8px] border-gray-500 bg-center bg-no-repeat bg-cover"
                        style={{ backgroundImage: `url(${gameBackgroundUrl})`, }}>
                        <div className='w-full h-full bg-[#181D29] bg-opacity-80 rounded-lg shadow-lg '>
                            {showPaylines && <Paylines lineForBet={lineForBet} setLineForBet={setLineForBet} onClose={() => { setShowPaylines(false); setActiveModel(null) }} />}
                            {showPayTable && <PayTable onClose={() => { setShowPayTable(false); setActiveModel(null) }} />}
                            {showSettings && <SystemSettings onClose={() => { setShowSettings(false); setActiveModel(null) }} bet={bet} setBet={setBet} turboOn={turboOn} setTurboOn={setTurboOn} soundOn={soundOn} setSoundOn={setSoundOn} ambientMusic={ambientMusic} setAmbientMusic={setAmbientMusic} setShowHistory={setShowHistory} setVolume={setVolume} balance={balance} />}
                            {showAutoPlay && <AutoPlay balance={balance} setAutoPlay={setAutoPlay} countAutoPlay={countAutoPlay} setCountAutoPlay={setCountAutoPlay} onClose={() => { setShowAutoPlay(false); setActiveModel(null) }} handleSpinCallback={handleSpinCallback} setAutoPlayLimit={setAutoPlayLimit} />}
                        </div>
                    </div>
                </div>
            }
            {showHistory && <History onClose={() => setShowHistory(false)} setFreeSpinDetail={setFreeSpinDetail} setPlayFreeSpin={setPlayFreeSpin} />}
            {showBetMultiplier && <BetMultiplier onClose={() => { setShowBetMultiplier(false); setBetAction(""); setActiveModel(null) }} betAction={betAction} bet={bet} setBet={setBet} lineForBet={lineForBet} balance={balance} />}
            {showVolume && (
                <div ref={volumeRef} className="fixed bottom-[14%] left-[2%] bg-white rounded-xl w-[15%] h-[6%] grid grid-cols-[auto_1fr_auto] items-center gap-1 xs:py-0.5 xs:px-1 lg:py-2 lg:px-3 shadow-lg">
                    {/* Volume Icon */}
                    <div
                        className="xs:w-4 xs:h-4 md:w-5 md:h-5 bg-cover bg-no-repeat"
                        style={{
                            backgroundImage: `url("/volume-high-blue.png")`,
                            backgroundSize: "100% 100%"
                        }}
                    ></div>

                    {/* Volume Slider */}
                    <input
                        type="range"
                        min="0"
                        max="100"
                        value={volume}
                        onChange={(e) => setVolume(Number(e.target.value))}
                        className="w-full h-1 rounded-lg appearance-none cursor-pointer 
                                [&::-webkit-slider-runnable-track]:h-1 [&::-webkit-slider-runnable-track]:rounded-lg 
                                [&::-moz-range-track]:h-1 [&::-moz-range-track]:rounded-lg 

                                [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full 
                                [&::-webkit-slider-thumb]:bg-black [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 
                                md:[&::-webkit-slider-thumb]:w-4 md:[&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:-mt-1

                                [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-black 
                                xs:[&::-moz-range-thumb]:w-1 xs:[&::-moz-range-thumb]:h-1 lg:[&::-moz-range-thumb]:w-4 lg:[&::-moz-range-thumb]:h-4"
                        style={{
                            background: `linear-gradient(to right, #3b82f6 ${volume}%, #e5e7eb ${volume}%)`
                        }}
                    />
                    {/* Volume Value */}
                    <span className="xs:text-xs lg:text-base font-medium xs:w-5 lg:w-8 text-right">{volume}</span>
                </div>
            )}
        </div>
    )
}

export default GamePopup